import { AiOutlineMonitor, AiOutlineUser } from "react-icons/ai";
import { MdAccountCircle, MdBrowserNotSupported, MdGrid3X3, MdGridView, MdGroup, MdGroups, MdInsertChartOutlined, MdMonitor, MdOutlineAdminPanelSettings, MdPerson } from "react-icons/md";

// Page Title: Comprehensive Proctoring Solution
export const webAgencyData = [
    {
        title: "Clients Management",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdGroups className='text-white fs-5' />
    },
    {
        title: "Application Management",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdGridView className='text-white fs-5' />
    },
    {
        title: "User Access Control",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdPerson className='text-white fs-5' />
    },
    {
        title: "Centralized Account Management",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdAccountCircle className='text-white fs-5' />
    }
]